import { render, staticRenderFns } from "./EnneagramDisplay.vue?vue&type=template&id=36dc5f28&scoped=true&"
import script from "./EnneagramDisplay.vue?vue&type=script&lang=js&"
export * from "./EnneagramDisplay.vue?vue&type=script&lang=js&"
import style0 from "./EnneagramDisplay.vue?vue&type=style&index=0&id=36dc5f28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36dc5f28",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VCard,VCardText,VCol,VIcon,VRow,VSheet,VSimpleTable})
